import { selectBrandGridSx } from './selectBrandStyles'

/** Figma 5181:9524 — Claimed Reward tab */
export const claimedRewardHeading = '#09090B'
export const claimedRewardCount = '#008CD0'
export const claimedRewardCardTitle = '#0D1B2A'
export const claimedRewardDate = '#A0ABBF'
export const claimedRewardAmountText = '#006192'
export const claimedRewardAmountBg = 'rgba(204, 229, 255, 0.3)'
export const claimedRewardAmountBorder = '#CCE5FF'
export const claimedRewardReadyBg = '#E8F5EF'
export const claimedRewardReadyBorder = '#B6E8D5'
export const claimedRewardReadyText = '#0E8A5F'
export const claimedRewardProcessingBg = 'rgba(255, 152, 0, 0.14)'
export const claimedRewardProcessingBorder = '#FF9800'
export const claimedRewardProcessingText = '#FF9800'
export const claimedRewardFailedBg = 'rgba(239, 68, 68, 0.12)'
export const claimedRewardFailedBorder = '#EF4444'
export const claimedRewardFailedText = '#DC2626'
export const claimedRewardViewButton = '#008CD0'
export const claimedRewardViewDisabled = '#94A3B8'

export const claimedRewardsHeaderSx = {
  mb: '14px',
} as const

export const claimedRewardsTitleSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '18px',
  lineHeight: '28px',
  color: claimedRewardHeading,
  mb: '4px',
} as const

export const claimedRewardsCountSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  color: claimedRewardCount,
} as const

export const claimedRewardsGridSx = {
  ...selectBrandGridSx,
} as const

export const claimedRewardCardSx = {
  width: '100%',
  minWidth: 0,
  minHeight: '215px',
  bgcolor: '#FFFFFF',
  border: '1px solid #E8EDF2',
  borderRadius: '16px',
  boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.05)',
  p: '18px',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
} as const

export const claimedRewardBrandRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  mb: '13px',
  minWidth: 0,
} as const

export const claimedRewardLogoSx = {
  width: 36,
  height: 36,
  borderRadius: '8px',
  objectFit: 'cover' as const,
  flexShrink: 0,
} as const

export const claimedRewardLogoPlaceholderSx = {
  width: 36,
  height: 36,
  borderRadius: '8px',
  bgcolor: '#E6ECFF',
  border: '1px solid #BDCEFF',
  flexShrink: 0,
} as const

export const claimedRewardBrandNameSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '24px',
  color: claimedRewardCardTitle,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
  flex: 1,
} as const

export const claimedRewardBadgesRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  flexWrap: 'wrap',
  mb: '13px',
} as const

export const claimedRewardAmountPillSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: claimedRewardAmountBg,
  border: `1px solid ${claimedRewardAmountBorder}`,
  borderRadius: '30px',
  px: '25px',
  height: '31px',
  boxSizing: 'border-box',
} as const

export const claimedRewardAmountTextSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '24px',
  color: claimedRewardAmountText,
  whiteSpace: 'nowrap',
} as const

export const claimedRewardStatusReadySx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: claimedRewardReadyBg,
  border: `1px solid ${claimedRewardReadyBorder}`,
  borderRadius: '20px',
  px: '13px',
  height: '31px',
  boxSizing: 'border-box',
} as const

export const claimedRewardStatusReadyTextSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '18px',
  color: claimedRewardReadyText,
} as const

export const claimedRewardStatusProcessingSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: claimedRewardProcessingBg,
  border: `1px solid ${claimedRewardProcessingBorder}`,
  borderRadius: '20px',
  px: '13px',
  height: '31px',
  boxSizing: 'border-box',
} as const

export const claimedRewardStatusProcessingTextSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '18px',
  color: claimedRewardProcessingText,
} as const

export const claimedRewardStatusFailedSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: claimedRewardFailedBg,
  border: `1px solid ${claimedRewardFailedBorder}`,
  borderRadius: '20px',
  px: '13px',
  height: '31px',
  boxSizing: 'border-box',
} as const

export const claimedRewardStatusFailedTextSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '18px',
  color: claimedRewardFailedText,
} as const

export const claimedRewardDateRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  color: claimedRewardDate,
  mb: 'auto',
} as const

export const claimedRewardDateTextSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 400,
  fontSize: '13px',
  lineHeight: '19.5px',
  color: claimedRewardDate,
} as const

export const claimedRewardViewButtonSx = {
  mt: '16px',
  width: '100%',
  maxWidth: '235px',
  alignSelf: 'center',
  height: '44px',
  borderRadius: '10px',
  textTransform: 'none',
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '21px',
  bgcolor: claimedRewardViewButton,
  boxShadow: 'none',
  '&:hover': {
    bgcolor: '#007AB8',
  },
  '&.Mui-disabled': {
    bgcolor: claimedRewardViewDisabled,
    color: '#FFFFFF',
  },
} as const
